import React from "react";
import { Link } from "react-router-dom";
import AppWrapper from "../Common/AppWrapper/index.jsx";
import FeaturedTable from "./FeaturedTable.jsx";
import "./FeaturedContent.scss";

const FeaturedCellAndGeneTherapy = () => {
  return (
    <AppWrapper
      id="featured-cgt"
      pageTitle="Featured Cell and Gene Therapy"
      pageKeywords="Featured Cell and Gene Therapy, expert design, curated list"
      pageDescription="Bio-Rad offers Cell and Gene Therapy Expert Design assays to help you quantify CAR-T transgene copy number as well as measure AAV viral genome titer in addition to a Cell and Gene Therapy Assay Design Engine for ordering custom Gene of Interest (GOI) assays."
    >
      <div id="bg">
        <div id="bg-inner"></div>
      </div>
      <div className="container main-content">
        <div id="page-header">
          <div id="page-header-inner" className="row align-items-center">
            <div className="col-md-9">
              <h1>Cell and Gene Therapy</h1>
              <h2 className="h3">
                Your partner from discovery to therapeutics
              </h2>
            </div>

            <div className="col-md-3">
              {/*
                <div className="btn-app float-right">
                  <Link to="/digital-assays/assays-create/cell-and-gene-therapy">
                    <img
                      className="default"
                      src={require("../../digital-assays/assets/images/icons/icon_cgt-white.svg")}
                    />
                    <img
                      className="hover"
                      src={require("../../digital-assays/assets/images/icons/icon_cgt-white-hover.svg")}
                    />

                    <div className="text-center">
                      <span>
                        Cell and Gene
                        <br />
                        Therapy
                      </span>
                    </div>
                  </Link>
                </div>

                */}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="copy">
              <p>
                Cell and Gene Therapies have rapidly gained popularity, but
                ensuring safety and effectiveness in patients is complex and
                there is no room for error. Research and clinical laboratories
                around the world are taking advantage of the accuracy of
                Bio-Rad's Droplet Digital PCR technology as a tool to overcome
                challenges with existing methods for a range of applications in
                Cell and Gene Therapy.
              </p>

              <p>
                Below are available Cell and Gene Therapy Expert Design assays
                to help you quantify{" "}
                <strong>CAR-T transgene copy number</strong> as well as measure{" "}
                <strong>AAV viral genome titer</strong>. Bio-Rad also offers a
                Cell and Gene Therapy Assay Design Engine for ordering custom
                Gene of Interest (GOI) assays. With our Expert Designs and
                Design Engine, you can take full advantage of Bio-Rad
                scientists' deep ddPCR assay design experience to quickly find
                solutions that will work for you.
              </p>
            </div>

            <h2 className="h3 in-page">Cell Therapy</h2>
            <FeaturedTable type="cellTherapy" />
            <br />
            <br />
            <h2 className="h3 in-page">Gene Therapy</h2>
            <FeaturedTable type="geneTherapy" />

            <div id="call-to-action">
              <h1>Design Your Assay</h1>
              <div className="btn-app">
                <Link to="/digital-assays/assays-create/cell-and-gene-therapy">
                  <div className="btn-icon cgt" />
                  <span>
                    Cell and Gene
                    <br />
                    Therapy
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppWrapper>
  );
};

export default FeaturedCellAndGeneTherapy;
